import type { RouteRecordRaw } from 'vue-router'

export const adminReadingsRoutes: RouteRecordRaw[] = [
  {
    path: '/admin/readings',
    name: 'admin-readings',
    component: () => import('./pages/AdminReadingsPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/readings/:id',
    name: 'admin-reading-detail',
    component: () => import('./pages/AdminReadingDetailsPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
]
